import React, {Component} from 'react';
import {LayoutSidebar} from "../../Layout";
import {UserProfileContent} from "./UserProfileContent";
import {LocalStorage} from "../../utils/LocalStorage";
import {withRouterParams} from "../../utils/withRouterParams";
import { withTranslation } from 'react-i18next';

class UserProfileClass extends Component {
    constructor(props) {
        super(props);
        this.afterSuccessfulUserUpdated = this.afterSuccessfulUserUpdated.bind(this);
    }

    userId() {
        return LocalStorage.fetchUserId()
    }

    afterSuccessfulUserUpdated() {
        const { t } = this.props;
        alert(t('user.user_updated_successfully'))
    }

    render() {
        return (
            <div className="app-content">
                <LayoutSidebar/>
                <UserProfileContent userId={this.props.match.params.id}
                                   afterSuccessfulUserUpdated={this.afterSuccessfulUserUpdated}
                />
            </div>
        )
    }
}

const UserProfile = withRouterParams(withTranslation()(UserProfileClass));
export default UserProfile;
